import { queryOptions, useQuery } from '@tanstack/react-query';

import { exchangeRatesApi } from '../api/exchange-rates-api';

import { exchangeRateKeys } from './exchange-rate-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function exchangeRateListQueryOptions() {
  return queryOptions({ queryKey: exchangeRateKeys.list(), queryFn: exchangeRatesApi.list });
}

export function useExchangeRates() {
  return useQuery(exchangeRateListQueryOptions());
}
